<template>
  <!-- JD Pools: brand logo in place of the DocuSeal mark (see JDPOOLS.md) -->
  <img
    src="/jdpools-logo.png"
    alt="J.D. Pools"
    style="height: 40px; width: auto; max-width: none;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
